<ng-container>
  <div>
    @if (listData?.length || showManageOption) {
      <button
        class="btn btn-sm"
        [ngClass]="listData?.length ? 'btn-primary' : 'btn-outline-secondary'"
        (click)="
          openTemplate(
            siteData()?.id ? modifyUserListTemplate : modifySiteListTemplate
          )
        "
      >
        {{
          siteData()?.id
            ? listData?.length
              ? "See Preferred Guards"
              : "Preferred Guards"
            : "Preferred Sites"
        }}
      </button>
    }
    <!--the outer div is necessary for correct padding and matching other div dls-->
    <!-- @if (listData?.length) {
      <dl id="siteKeys">
        <div class="d-flex align-items-center gap-3">
          <div>
            <dt>
              {{ siteData()?.id ? "Preferred Guards" : "Preferred Sites" }}
            </dt>
          </div>
          @if (showManageOption) {
            <div
              (click)="
                openTemplate(
                  siteData()?.id
                    ? modifyUserListTemplate
                    : modifySiteListTemplate
                )
              "
            >
              <i class="fa-solid fa-plus md-font-size text-body opacity-75"></i>
            </div>
          }
        </div>
        <dd class="d-flex flex-wrap gap-2 overflow-25vh">
          
          @for (item of listData; track item?.id) {
            <div
              class="border px-2 py-1 rounded bg-secondary-subtle text-dark d-flex align-items-center"
            >
              @if (siteData()?.id) {
                {{ item?.full_name }}
              } @else {
                {{ item?.company_name }}
                @if (item?.company?.company_name) {
                  <div>
                    {{ item?.company?.company_name }}
                  </div>
                }
              }
            </div>
          }
        </dd>
      </dl>
    } @else if (showManageOption) {
      
      <dl>
        <div class="p-2 mb-2 small border border-1 rounded-2">
          <div class="d-flex">
            <dt>
              {{ siteData()?.id ? "Preferred Guards" : "Preferred Sites" }}
            </dt>

            <span
              class="ms-auto"
              (click)="
                openTemplate(
                  siteData()?.id
                    ? modifyUserListTemplate
                    : modifySiteListTemplate
                )
              "
              ><i class="fa-solid fa-plus text-body opacity-75 fa-2x"></i
            ></span>
          </div>
          <div class="d-flex">
            No {{ siteData()?.id ? "gaurds" : "sites" }} have been added yet.
          </div>
        </div>
      </dl>
    } -->
  </div>
</ng-container>

<ng-template #modifySiteListTemplate let-modifySiteListTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Modify Sites
      <span class="float-end" (click)="modifySiteListTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-4">
      @for (siteInfo of selectedSiteListData; track $index; let i = $index) {
        @if (siteInfo?.id) {
          <ul>
            <li>
              <dl class="px-2 px-md-4">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dd
                      (click)="
                        editField('site'); selectedSiteListData?.splice(i, 1)
                      "
                      class="link-edit"
                    >
                      {{ siteInfo?.company_name }}
                      @if (siteInfo?.company?.company_name) {
                        <span> [{{ siteInfo?.company?.company_name }}] </span>
                      }
                    </dd>
                  </div>
                </div>
              </dl>
            </li>
          </ul>
        } @else {
          <ng-container>
            <gtapp-auto-complete
              [data]="siteListData"
              placeHolder="Add Site"
              searchKeyword="company_name"
              [itemTemplate]="siteTemplate"
              (inputChanged)="onSiteSearch($event)"
              (selected)="
                selectedSiteListData[i] = $event;
                selectedSiteListData.push({});
                checkSiteSelection()
              "
              inputId="siteId"
              [enableCloseOption]="true"
              (fieldCleared)="editField('site')"
              (inputFocused)="inputFocused('site')"
            >
            </gtapp-auto-complete>
            <ng-template #siteTemplate let-item>
              <div>
                <div class="fw-medium">
                  {{ item?.company_name }} [{{ item?.company?.company_name }}]
                </div>

                <div class="small-font text-secondary">
                  {{ item?.address?.full_address }}
                </div>
              </div>
            </ng-template>
          </ng-container>
        }
      }
    </div>
    <div class="row g-2">
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-dark w-100"
          (click)="modifySiteListTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-success w-100"
          [disabled]="
            !selectedSiteListData[selectedSiteListData?.length - 1]?.id ||
            haveSameSiteIdList
          "
          (click)="modifySiteListTemplateRef.close(true)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modifyUserListTemplate let-modifyUserListTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Modify Guards
      <span class="float-end" (click)="modifyUserListTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <gtapp-select-users
      [onSelectedUsersInput]="selectedUserListData"
      (onSelectUser)="onSelectUser($event)"
    ></gtapp-select-users>

    <div class="my-3 d-flex justify-content-end text-small text-secondary">
      Selected Guards: {{ selectedUserListData?.length }}
    </div>

    <div class="row g-2 my-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-darkn-light w-100"
          (click)="modifyUserListTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-primary w-100"
          [disabled]="haveSameUserIdList"
          (click)="modifyUserListTemplateRef.close(true)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
